import React, { useEffect, useState } from "react";
import { GeneralDetail, Edit } from "../../assets/svg";
import { useDispatch, useSelector } from "react-redux";
import { AddPrimaryButton } from "../../components/micro/input";
import AddEditBillingModal from "./AddEditBilling";
import { getBillingSettingList } from "../../redux/masterSetting/slice";
import RippleLoader from "../../components/loader/RippleLoader";

const BillingSetting = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isType, setIsType] = useState("");
  const [isMode, setIsMode] = useState("");
  const [selectedData, setSelectedData] = useState(null);

  // Selector
  const { billingSettingData, loading } = useSelector((store) => ({
    billingSettingData:
      store?.settingData?.getBillingSettingListStatus?.data?.data,
    loading: store?.settingData?.loading,
  }));

  useEffect(() => {
    dispatch(getBillingSettingList());
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedData(null);
  };

  return (
    <>
      {loading ? (
        <RippleLoader />
      ) : (
        <div>
          {billingSettingData?.data.map((item, index) => (
            <div className="flex gap-2">
              <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg">
                <div className="flex items-center justify-between bg-background_grey py-5 px-6 border-b border-b-Grey">
                  <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey font-Montserrat">
                    <GeneralDetail />
                    <span className="font-Montserrat">Billing Details</span>
                  </h2>
                  {billingSettingData ? (
                    <button
                      className="cursor-pointer"
                      onClick={() => {
                        setIsModalOpen(true);
                        setIsType("edit");
                        setIsMode("billing");
                        setSelectedData(item);
                      }}
                    >
                      <Edit />
                    </button>
                  ) : (
                    <AddPrimaryButton
                      value="ADD"
                      onClick={() => {
                        setIsModalOpen(true);
                        setIsType("add");
                        setIsMode("billing");
                      }}
                    />
                  )}
                </div>
                <div className="py-5 px-6 grid grid-cols-2 gap-y-4 ">
                  <div className="space-y-1">
                    <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                      Mobile Number:
                    </p>
                    <p className="text-sm font-normal text-mgrey font-Proxima">
                      {item?.mobile || "-"}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                      Email:
                    </p>
                    <p className="text-sm font-normal text-mgrey font-Proxima">
                      {item?.email || "-"}
                    </p>
                  </div>
                  <div className="space-y-1 w-40">
                    <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                      Address:
                    </p>
                    <div className="text-sm font-normal text-mgrey font-Proxima">
                      <p className="text-sm font-normal text-mgrey font-Proxima">
                        {(item?.address || "-")
                          .replace(/\s+/g, " ")
                          .replace(/\s*,\s*/g, ", ")
                          .trim()}
                      </p>
                    </div>
                  </div>
                  <div className=" space-y-1">
                    <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                      Postal code:
                    </p>
                    <div className="text-sm font-normal text-mgrey font-Proxima">
                      <p className="text-sm font-normal text-mgrey font-Proxima">
                        {item?.postal_code || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg">
                <div className="flex items-center justify-between bg-background_grey py-5 px-6 border-b border-b-Grey">
                  <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey font-Montserrat">
                    <GeneralDetail />
                    <span className="font-Montserrat">GST Setting</span>
                  </h2>
                  {billingSettingData ? (
                    <button
                      className="cursor-pointer"
                      onClick={() => {
                        setIsModalOpen(true);
                        setIsType("edit");
                        setIsMode("gst");
                        setSelectedData(item);
                      }}
                    >
                      <Edit />
                    </button>
                  ) : (
                    <AddPrimaryButton
                      value="ADD"
                      onClick={() => {
                        setIsModalOpen(true);
                        setIsType("add");
                        setIsMode("gst");
                      }}
                    />
                  )}
                </div>
                <div className="py-5 px-6 grid grid-cols-2 gap-y-4 ">
                  <div className="space-y-1">
                    <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                      Current GST:
                    </p>
                    <p className="text-sm font-normal text-mgrey font-Proxima">
                      {billingSettingData?.data?.map((item, index) => (
                        <span key={index}>{item.gst}%</span>
                      ))}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {isModalOpen && (
        <div>
          <AddEditBillingModal
            onClose={closeModal}
            companyData={billingSettingData}
            isType={isType}
            isMode={isMode}
            selectedData={selectedData}
          />
        </div>
      )}
    </>
  );
};

export default BillingSetting;
